var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLogoDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 107.9 14.2827 132.465 35.9354 146.781C36.4883 147.147 36.8 147.846 36.8 148.571C36.8 149.834 35.7766 150.857 34.5143 150.857H29.7143C27.1896 150.857 25.1429 152.904 25.1429 155.429C25.1429 157.953 27.1896 160 29.7143 160H80Z",
    fill: "#1570EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.669 63.9936L58.4279 44.3689C54.6129 42.5965 50.0841 43.3789 47.1028 46.3252L44.8324 48.5689L73.2081 72.8174L100.669 63.9936Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.995 59.5351C132.995 63.2573 130.689 66.4409 127.427 67.734L127.442 67.7753L48.0031 98.5207C46.8962 99.0214 45.6673 99.3002 44.3734 99.3002C40.5815 99.3002 37.3487 96.9063 36.1039 93.5474L27.328 73.0892C26.9989 72.3251 27.3251 71.4346 28.0715 71.0614L28.6563 70.7705C31.5628 69.3217 35.057 69.7772 37.4932 71.9225L46.333 79.7043L121.241 51.2069L121.245 51.2188C122.163 50.8949 123.15 50.7188 124.179 50.7188C129.048 50.7188 132.995 54.6659 132.995 59.5351Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2274 78.6062C78.2077 78.9951 77.5054 79.9482 77.4261 81.0467L74.2201 125.716H77.3644C81.493 125.716 85.1809 123.097 86.5767 119.175L103.526 71.6735C103.911 70.5987 102.868 69.5626 101.81 69.9693L79.2274 78.6062Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogoDev);
export default __webpack_public_path__ + "static/media/app-logo-dev.4c35f548d4b7299c5524a1c0e23264c5.svg";
export { ForwardRef as ReactComponent };